import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { Label } from '~/components/ui/label'
import { Switch } from '~/components/ui/switch'

type FormSwitchProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
  control: Control<TFieldValues>
  name: TName
  label?: string
  disabled?: boolean
}

export function FormSwitch<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  disabled,
}: FormSwitchProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div className="flex items-center justify-between">
          {label && (
            <Label htmlFor={String(name)} className="cursor-pointer">
              {label}
            </Label>
          )}
          <Switch id={String(name)} checked={field.value} onCheckedChange={field.onChange} disabled={disabled} />
        </div>
      )}
    />
  )
}
